module.exports = __webpack_public_path__ + "img/jshengqi.6f2932c4.gif";